package pl.zar.tikthrow.ui.screen

import kotlinx.datetime.Instant
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

private val polishMonthsShort = listOf(
    "sty", "lut", "mar", "kwi", "maj", "cze",
    "lip", "sie", "wrz", "paź", "lis", "gru",
)

/**
 * Short Polish date, e.g. "12 sie 2026".
 *
 * Built on kotlinx-datetime rather than per-platform date APIs so every target formats
 * identically — the previous expect/actual left JVM, iOS and web rendering a literal "---".
 */
fun formatDateMillis(millis: Long): String {
    val date = Instant.fromEpochMilliseconds(millis)
        .toLocalDateTime(TimeZone.currentSystemDefault())
        .date
    val month = polishMonthsShort.getOrElse(date.monthNumber - 1) { "?" }
    return "${date.day} $month ${date.year}"
}
